import Router from 'next/router';
import { Builder } from 'builder-pattern';
import { isEmpty } from 'radash';
import { create } from 'zustand';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { favoriteStateStore } from '@modules/favorite/adapter/outbound/stores/favourite.store';
import { GetRecipeDetailUsecase } from '@modules/recipes/application/usecases/getRecipeDetail.usecase';
import { IRecipeDetail } from '@modules/recipes/domain/models/recipeDetail.model';
import { userStore } from '@modules/user/adapter/outbound/stores/user.store';
import { ModuleType } from '@shared/types/module.type';
import { StatusCodeType } from '@shared/types/statusCode.type';
import { RecipeDetailRepositoryImpl } from '../../inbound/repositories/recipeDetail.repository';
interface RecipeState {
  recipeDetail: IRecipeDetail;
  fetchRecipeDetail: (slug: string) => void;
  clearRecipeDetail: () => void;
}
const initialState = Builder<IRecipeDetail>().build();
export const recipeStore = create<RecipeState>((set, get) => ({
  recipeDetail: initialState,
  clearRecipeDetail: () => set({
    recipeDetail: initialState
  }),
  fetchRecipeDetail: async (slug: string): Promise<void> => {
    try {
      get().clearRecipeDetail();
      loadingStore.setState({
        isLoading: true
      });
      const recipeRepositoryImpl = new RecipeDetailRepositoryImpl();
      const getRecipeDetailUsecase = new GetRecipeDetailUsecase(recipeRepositoryImpl);
      const result = await getRecipeDetailUsecase.handle(slug);
      if (result.isRight()) {
        set(() => ({
          recipeDetail: result.value
        }));
        const {
          fetchFavoriteItemById
        } = favoriteStateStore.getState();
        const userDetail = userStore.getState().userDetail;
        const hasUser = !isEmpty(userDetail);
        if (hasUser) {
          fetchFavoriteItemById(result.value.id, ModuleType.Recipe);
        }
      }
    } catch (err) {
      console.error('error fetchRecipeDetail', err);
      if (err.statusCode === StatusCodeType.NotFound) {
        Router.push('/404');
      }
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  }
}));